<div class="card">
  <div class="card-content">
    <form (submit)="onSubmit($event)">
      <h4 class="is-size-5" style="
          margin-bottom: 15px;
          text-align: center;
          text-transform: uppercase;
        ">
        {{"CHANGE_PASSWORD" | translate}}
      </h4>
      <div class="field">
        <div class="control has-icons-left has-icons-right">
          <input (input)="handleFieldChange($event)" class="input" type="email" name="email"
            [ngClass]="{ 'is-danger': hasError('email') }" [placeholder]="'EMAIL' | translate" />
          <span class="icon is-small is-left">
            <i class="fas fa-envelope"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('email')">
          {{ getError('email') }}
        </p>
      </div>

      <div class="field">
        <div class="control has-icons-left has-icons-right">
          <input (input)="handleFieldChange($event)" class="input" type="password" name="password"
            [ngClass]="{ 'is-danger': hasError('password') }" [placeholder]="'PASSWORD' | translate" />
          <span class="icon is-small is-left">
            <i class="fas fa-lock"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('password')">
          {{ getError('password') }}
        </p>
      </div>

      <div class="field">
        <div class="control has-icons-left has-icons-right">
          <input (input)="handleFieldChange($event)" class="input" type="password" name="passwordConfirm"
            [ngClass]="{ 'is-danger': hasError('passwordConfirm') }"
            [placeholder]="'PASSWORD_CONFIRMATION' | translate" />
          <span class="icon is-small is-left">
            <i class="fas fa-lock"></i>
          </span>
        </div>
        <p class="help is-danger" *ngIf="hasError('passwordConfirm')">
          {{ getError('passwordConfirm') }}
        </p>
      </div>

      <div class="buttons">
        <button class="button is-fullwidth is-link is-outlined" type="submit" [disabled]="isLoading">
          {{"SUBMIT" | translate}}
        </button>

        <a class="button is-light is-fullwidth" [routerLink]="['/auth/login']">{{"BACK_TO_LOGIN" | translate}}</a>
      </div>
    </form>
  </div>
</div>